import React from 'react';
import { Container, Grid, Segment, Header, Button } from 'semantic-ui-react';
import './customerDetail_styles.css';

export const ChargingRates = () => {
  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">CHARGING RATES</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        style={{
                          width: '100%'
                        }}
                        color="olive"
                      >
                        <a
                          className="tel-anchor"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://trojan.energy/hubpricing"
                        >
                          VIEW TARIFF GUIDE ON TROJAN WEBSITE
                        </a>
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
